import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import TermsAndPoliciesBox from '../../../TermsAndPoliciesBox';
import DateDropdown from '../../../common/DateDropdown';
import SelectCustom from '../../../SelectCustom';
import TextInput from '../../../TextInput';
import styles from '../../index.styles';

const {
  LAST_NAME,
  FIRST_NAME,
  DOB,
  NAME_SUFFIX,
  COUNTRY,
  ACCEPTED_TERMS_AND_CONDITIONS,
  ACCEPTED_PRIVACY_POLICY,
  GENDER,
} = PROFILE_FIELDS_TYPES;

const AuthPersonalInfoForm = ({
  firstName,
  lastName,
  validateErrors,
  nameSuffixList,
  nameSuffix,
  dob,
  formatMessage,
  onChange,
  profileEditable,
  acceptedPrivacyPolicy,
  termsAndConditionsAccepted,
  showPrivacy,
  countries,
  country,
  gender,
  genderList,
  countryForOrganization,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);
  return (
    <Fragment>
      {/*     F I R S T   N A M E     */}
      <TextInput
        {...makeProfileField(FIRST_NAME)}
        value={firstName}
        disabled={!profileEditable}
        className={cn(styles.labelField, styles.inputField, 'mb3')}
      />
      <FormErrorBlock type={FIRST_NAME} errors={validateErrors} />
      {/*     L A S T   N A M E     */}
      <TextInput
        {...makeProfileField(LAST_NAME)}
        value={lastName}
        disabled={!profileEditable}
        className={cn(styles.labelField, styles.inputField, 'mb3')}
      />
      <FormErrorBlock type={LAST_NAME} errors={validateErrors} />
      {/*     N A M E   S U F F I X     */}
      <SelectCustom
        {...makeProfileField(NAME_SUFFIX)}
        options={nameSuffixList}
        value={nameSuffix}
        needUpdateDefaultValue
        className={cn(styles.labelField, styles.selectField, 'mb3')}
      />
      {/*     D O B     */}
      <DateDropdown
        {...makeProfileField(DOB)}
        value={dob}
        disabled={!profileEditable}
        className={cn(styles.labelField, styles.selectField, 'mb3')}
      />
      {/*     GENDER    */}
      <SelectCustom
        {...makeProfileField(GENDER)}
        value={gender}
        options={genderList}
        needUpdateDefaultValue
        className={cn(styles.labelField, styles.selectField, 'mb3')}
      />
      {/* Commented for possible future logic */}
      {/* RACE
      <SelectCustom
        {...makeProfileField(RACE)}
        value={race}
        options={races}
        needUpdateDefaultValue
        className={cn(styles.labelField, styles.selectField, 'mb3')}
      />
          ETHNICITY
      <SelectCustom
        {...makeProfileField(ETHNICITY)}
        value={ethnicity}
        options={ethnicitys}
        needUpdateDefaultValue
        className={cn(styles.labelField, styles.selectField, 'mb3')}
      /> */}
      {showPrivacy && (
        <Fragment>
          {/*     COUNTRY   */}
          <SelectCustom
            {...makeProfileField(COUNTRY, FIELD_FILLING_TYPES.REQUIRED)}
            options={countries}
            value={country}
            readOnly={Boolean(countryForOrganization)}
            needUpdateDefaultValue
            className={cn(styles.labelField, styles.selectField, 'mb3')}
            required
            onChange={value => {
              onChange({
                [ACCEPTED_TERMS_AND_CONDITIONS]: false,
                [ACCEPTED_PRIVACY_POLICY]: false,
                [COUNTRY]: value.value,
              });
            }}
          />
          {/*     TERMS AND POLICY   */}
          <TermsAndPoliciesBox
            {...makeProfileField(
              ACCEPTED_TERMS_AND_CONDITIONS,
              FIELD_FILLING_TYPES.REQUIRED,
            )}
            termsValue={termsAndConditionsAccepted}
            privacyValue={acceptedPrivacyPolicy}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

AuthPersonalInfoForm.propTypes = {
  validateErrors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  nameSuffixList: PropTypes.array,
  nameSuffix: PropTypes.string,
  formatMessage: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onChange: PropTypes.func,
  dob: PropTypes.string,
  profileEditable: PropTypes.bool,
  primaryPatientProfile: PropTypes.object,
  acceptedPrivacyPolicy: PropTypes.bool,
  termsAndConditionsAccepted: PropTypes.bool,
  showPrivacy: PropTypes.bool,
  countries: PropTypes.array.isRequired,
  country: PropTypes.string,
  gender: PropTypes.string,
  genderList: PropTypes.array,
  race: PropTypes.string,
  races: PropTypes.array,
  ethnicity: PropTypes.string,
  ethnicitys: PropTypes.array,
  countryForOrganization: PropTypes.string,
};

export default AuthPersonalInfoForm;



// WEBPACK FOOTER //
// ./src/components/Auth/AuthPersonalInfo/AuthPersonalInfoForm/index.jsx